import { Component, Input, Output, OnInit, AfterViewInit, OnChanges, SimpleChanges, EventEmitter } from "@angular/core";
import { JqueryExtensionsService } from "../services/jquery.service";
import { StringExtensions } from "../utilities/string.extensions";

@Component({
	selector: "switch-button",
  template: `<input [id]="id" type="checkbox" [(ngModel)]="state" [checked]="state" [disabled]="disabled"/>`
})
export class SwitchButtonComponent implements OnInit, OnChanges, AfterViewInit {
	@Input() id: string;
	@Input() state = false;
	@Input() disabled = false;
  @Output() onChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() onClick = new EventEmitter();

	protected element: JQuery;

	constructor(private jqueryService: JqueryExtensionsService) { }

  ngOnInit() {
    if (!this.id) { this.id = "switch-button-" + StringExtensions.generateUUID(); }
	}

	ngOnChanges(changes: SimpleChanges) {

		if (changes["disabled"] && changes["disabled"].currentValue !== changes["disabled"].previousValue) {
			this.jqueryService.bootstrapSwitchChangeDisabled("#" + this.id, changes["disabled"].currentValue);
		}

		if (changes["state"] && changes["state"].currentValue !== changes["state"].previousValue) {
			if (this.disabled) {
				this.jqueryService.bootstrapSwitchChangeDisabled("#" + this.id, false);
				this.jqueryService.bootstrapSwitchChangeState("#" + this.id, changes["state"].currentValue);
				this.jqueryService.bootstrapSwitchChangeDisabled("#" + this.id, this.disabled);
			} else {
				this.jqueryService.bootstrapSwitchChangeState("#" + this.id, changes["state"].currentValue);
			}
		}
	}

  ngAfterViewInit() {
    let self = this;
    this.element = this.jqueryService.bootstrapSwitch("#" + this.id, this.state, this.disabled);

    setTimeout(() => {
      this.element = this.jqueryService.getBootstrapSwitch("#" + this.id);	
			$("#" + this.id).on("switchChange.bootstrapSwitch", function (...args: Array<any>) {
				self.onChange.emit(args[1] || false);
      });
      $("#" + this.id).on("switchChange.bootstrapSwitch", function (...args: Array<any>) {
        self.onClick.emit(args[1]);
      });
		});
	}
}
